import React, { forwardRef, InputHTMLAttributes, LegacyRef } from 'react';
import { Container } from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  type: string;
  width?: string;
  label?: string;
}

const Input = (
  { type, label, width = '100%', ...rest }: InputProps,
  ref: LegacyRef<HTMLInputElement>,
) => {
  return (
    <Container {...rest} width={width}>
      {label && <label>{label}</label>}
      <input type={type} ref={ref} {...rest} />
    </Container>
  );
};

export default forwardRef(Input);
